
import React from "react";

interface ReadOnlyProfileProps {
  profile: any;
}

export function ReadOnlyProfile({ profile }: ReadOnlyProfileProps) {
  return (
    <div className="space-y-4 text-sm">
      {profile.title && (
        <div>
          <h4 className="font-medium text-slate-700">Professional Title</h4>
          <p className="text-slate-600">{profile.title}</p>
        </div>
      )}
      
      {profile.bio && (
        <div>
          <h4 className="font-medium text-slate-700">Bio</h4>
          <p className="text-slate-600 whitespace-pre-wrap">{profile.bio}</p>
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {profile.location && (
          <div>
            <h4 className="font-medium text-slate-700">Location</h4>
            <p className="text-slate-600">{profile.location}</p>
          </div>
        )}
        
        {profile.website && (
          <div>
            <h4 className="font-medium text-slate-700">Website</h4>
            <a 
              href={profile.website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              {profile.website}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
